export function createPageUrl(page) {
  const routes = {
    Home: "/",
    ManholeCoverProducts: "/products/manhole-covers",
    PipesFittingsProducts: "/products/pipes-fittings",
    ValvesFastenersProducts: "/products/valves-fasteners",
    InsulatorsProducts: "/products/insulators",
  };

  if (!routes[page]) {
    console.warn(`Unknown page key: ${page}`);
    return "/";
  }

  return routes[page];
}
